import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-light shadow-sm border-top text-black py-2 mt-auto">
      <div className="container text-center">
        <p className="mb-0 fs-14">©SUPRAVI {currentYear} All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
